import { render } from "./academicCouncil.vue?vue&type=template&id=032e10fa"
import script from "./academicCouncil.vue?vue&type=script&lang=js"
export * from "./academicCouncil.vue?vue&type=script&lang=js"

import exportComponent from "F:\\desktop2025\\UG_College_administration\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__